export default __webpack_public_path__ + "static/media/exam-overview-passed-icon.fe851ed6.svg";